import React from 'react';

const sizes = {
  small: ['16px', '16px'],
  middle: ['24px', '24px'],
  large: ['32px', '32px'],
  huge: ['64px', '64px'],
};

const AddIcon = (props) => {
  const width = sizes[props.size][0];
  const height = sizes[props.size][1];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      style={{
        ...(props.shouldPadding
          ? {
              padding: '4px',
            }
          : {}),
      }}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13 11V7a1 1 0 00-2 0v4H7a1 1 0 000 2h4v4a1 1 0 002 0v-4h4a1 1 0 000-2h-4z"
      />
    </svg>
  );
};

export default AddIcon;
